import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import DistributorManager from '@/components/v2/distributor/DistributorManager.vue';
import ActionButton from '@/components/action_button/Index.vue';
let Distributors = class Distributors extends Mixins() {
    get headers() {
        return [
            {
                text: 'DISTRIBUTOR NAME',
                value: 'distributorName',
                align: 'left',
                sortable: false,
            },
            {
                text: 'ADDRESS',
                value: 'address',
                align: 'left',
                sortable: false,
            },
            {
                text: 'ASSIGNED LOCATION',
                value: 'assignedLocation',
                align: 'left',
                sortable: false,
            },
            {
                text: 'CONTACT NUMBER',
                value: 'contactNumber',
                align: 'left',
                sortable: false,
            },
            {
                text: 'ADMIN EMAIL',
                value: 'adminEmail',
                align: 'left',
                sortable: false,
            },
            {
                text: 'DEFAULT',
                value: 'default',
                align: 'left',
                sortable: false,
            },
        ];
    }
};
Distributors = __decorate([
    Component({
        components: {
            DistributorManager,
            ActionButton,
        },
    })
], Distributors);
export default Distributors;
